import './XYChartTooltip.css';
export var body = '_1fpx2hs0-2-0-1';